import { render, staticRenderFns } from "./QuickCreateLink.vue?vue&type=template&id=31cbd41c&scoped=true&"
import script from "./QuickCreateLink.vue?vue&type=script&lang=js&"
export * from "./QuickCreateLink.vue?vue&type=script&lang=js&"
import style0 from "./QuickCreateLink.vue?vue&type=style&index=0&id=31cbd41c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cbd41c",
  null
  
)

export default component.exports